enum SelectionDirection {
    // None
    None = 0,

    // Previous
    Previous = 1,

    // Next
    Next = 2,
}

export default SelectionDirection;
